import * as React from "react";
import { DefaultButton } from "@fluentui/react/lib/Button";
import { strings } from "@src/i18n/strings";

const overlayStyle: React.CSSProperties = {
  position: "fixed",
  inset: 0,
  backgroundColor: "rgba(0, 0, 0, 0.4)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 1000,
};
const modalStyle: React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
  gap: "1rem",
  padding: "1.5rem",
  backgroundColor: "#fff",
  borderRadius: "4px",
  boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
  maxWidth: "400px",
  width: "90%",
};
const messageStyle: React.CSSProperties = {
  fontSize: "14px",
  color: "#323130",
  lineHeight: 1.5,
  margin: 0,
};
const buttonRowStyle: React.CSSProperties = {
  display: "flex",
  gap: "12px",
  justifyContent: "flex-end",
  marginTop: "8px",
};

export interface ConfirmDialogProps {
  open: boolean;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel: () => void;
}
export default function ConfirmDialog({
  open,
  title,
  message,
  confirmText = strings.components.confirmDialog.confirmText,
  cancelText = strings.components.confirmDialog.cancelText,
  onConfirm,
  onCancel,
}: ConfirmDialogProps) {
  const handleOverlayClick = React.useCallback(
    (e: React.MouseEvent) => {
      if (e.target === e.currentTarget) onCancel();
    },
    [onCancel]
  );

  if (!open) return null;
  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="confirm-dialog-title"
      style={overlayStyle}
      onClick={handleOverlayClick}
    >
      <div style={modalStyle} onClick={(e) => e.stopPropagation()}>
        <h2 id="confirm-dialog-title" style={{ margin: 0, fontSize: "16px", fontWeight: 600 }}>
          {title}
        </h2>
        <p style={messageStyle}>{message}</p>
        <div style={buttonRowStyle}>
          <DefaultButton text={cancelText} onClick={onCancel} />
          <DefaultButton text={confirmText} primary onClick={onConfirm} />
        </div>
      </div>
    </div>
  );
}
